import ITooltip from './itooltip'

/* istanbul ignore next */
ITooltip.install = function(Vue) {
    Vue.component(ITooltip.name, ITooltip)
}

export default ITooltip
